import React from "react";
import {isAuthorized} from "../../api/authorization/authorization-service";
import {Toast} from "primereact/toast";
import {Navigate, Route, Routes} from "react-router-dom";
import Aux from "../../hoc/Auxiliary";
import NotAuthorized from "../../components/NotAuthorized/NotAuthorized";
import DataCollectionBuilder from "../../containers/DataCollection/DataCollectionBuilder";
import DataCollectionEditor from "../../containers/DataCollection/DataCollectionEditor";
import ErrorServer from "../../components/ErrorServer/ErrorServer";
import DataCollectionQueriesBuilder
    from "../../containers/DataCollectionQueries/Configuration/DataCollectionQueriesBuilder";
import DataCollectionDetails from "../../containers/DataCollectionDetails/DataCollectionDetails";
import DataUploadBuilder from "../../containers/DataUpload/DataUploadBuilder";
import PemmdbVersionBuilder from "../../containers/PemmdbVersion/PemmdbVersionBuilder";
import DataCollectionListBuilder from "../../containers/DataCollections/DataCollectionListBuilder";
import DataCollectionQueriesForStudyTeams
    from "../../containers/StudyTeams/DataCollectionQueries/DataCollectionQueriesForStudyTeams";
import DataVisualisation from "../../components/DataCollection/DataCollections/DataVisualisation/DataVisualisation";
import StudyTeamsDataCollections from "../../containers/StudyTeams/PublishedDataCollections/StudyTeamsDataCollections";
import {
    ERROR_PATH,
    MANAGE_PERMISSIONS,
    NEW_DATA_COLLECTION_PATH,
    NOT_AUTHORIZED_PATH,
    STUDY_TEAM_SPACE_PATH
} from "../../api/static-data/Configurations";
import TokenListBuilder from "../../containers/TokenList/TokenListBuilder";
import TokenDetailsBuilder from "../../containers/TokenList/TokenDetailsBuilder";
import NewPEMMDBVersion from "../../components/PemmdbVersion/VersionCreator/NewPEMMDBVersion";
import PermissionScreen from "../../containers/PermissionManagement/PermissionScreen";
import PythonExecution from "../../containers/PythonExecution/PythonExecution";
import DataCollectionModelDocumentationPreview
    from "../../components/PemmdbVersion/DataModelDocumentation/DataCollectionModelDocumentationPreview";


const AppRoutes = () => {
    return (
        <Aux>
            <Toast ref={global.toastRef}/>
            <Routes>
                <Route path={NOT_AUTHORIZED_PATH} exact element={<NotAuthorized/>}/>
                <Route path={ERROR_PATH} exact element={<ErrorServer/>}/>
                <Route path={NEW_DATA_COLLECTION_PATH} exact
                       element={isAuthorized("AR08") ? <DataCollectionBuilder/> :
                           <NotAuthorized/>}/>
                <Route path="/data_collections/edit/:dcName" exact
                       element={isAuthorized("AR08") ? <DataCollectionBuilder/> :
                           <NotAuthorized/>}/>
                <Route path="/data_collections/edit/published/:dcName" exact
                       element={isAuthorized("AR08") ? <DataCollectionEditor/> :
                           <NotAuthorized/>}/>
                <Route path="/data_collections/:dcName/queries" exact
                       element={isAuthorized("AR030") ? <DataCollectionQueriesBuilder/> :
                           <NotAuthorized/>}/>
                <Route path="/data_collections/:dcName" exact element={<DataCollectionDetails/>}/>
                <Route path="/data_collections/:dcName/:marketNode" exact
                       element={isAuthorized("AR010") ? <DataUploadBuilder/> : <NotAuthorized/>}/>
                <Route path="/data_collections/:dcName/visualisation/dashboards" exact element={<DataVisualisation/>}/>
                <Route path="/data_collections/Dashboards" exact element={<DataVisualisation/>}/>

                <Route path="/pemmdb_versions" exact
                       element={isAuthorized("AR016") ? <PemmdbVersionBuilder/> :
                           <NotAuthorized/>}/>
                <Route path="/pemmdb_versions/new" exact
                       element={isAuthorized("AR015") ? <NewPEMMDBVersion/> : <NotAuthorized/>}/>
                <Route path="/pemmdb_versions/:version" exact
                       element={isAuthorized("AR015") ? <NewPEMMDBVersion/> : <NotAuthorized/>}/>
                <Route path="/data_collections" element={<DataCollectionListBuilder/>}/>
                <Route path={STUDY_TEAM_SPACE_PATH}
                       element={isAuthorized("AR041") ? <StudyTeamsDataCollections/> :
                           <NotAuthorized/>}/>
                <Route path={MANAGE_PERMISSIONS}
                       element={isAuthorized("AR04") ? <PermissionScreen/> :
                           <NotAuthorized/>}/>
                <Route path={STUDY_TEAM_SPACE_PATH + "/:dcName"}
                       element={isAuthorized("AR041") ? <DataCollectionQueriesForStudyTeams/> :
                           <NotAuthorized/>}/>
                <Route path={STUDY_TEAM_SPACE_PATH + "/:dcName/queries"} exact
                       element={isAuthorized("AR041") ? <DataCollectionQueriesForStudyTeams/> :
                           <NotAuthorized/>}/>
                <Route path="/access_key" exact
                       element={isAuthorized("AR036") ? <TokenListBuilder/> :
                           <TokenDetailsBuilder/>}/>
                <Route path={"/preview-data-model/dc/:dataCollection"} exact
                       element={<DataCollectionModelDocumentationPreview/>}/>
                <Route path={"/preview-data-model/dc/:dataCollection/:fileName/:hash"} exact
                       element={<DataCollectionModelDocumentationPreview/>}/>
                <Route path={"/python/executions"} exact
                       element={<PythonExecution/>}/>
                <Route path={"/python"} exact
                       element={<Navigate to="/python/executions" replace/>}/>
            </Routes>
        </Aux>
    )
}

export default AppRoutes;
